import { render, staticRenderFns } from "./resourceHandles.vue?vue&type=template&id=33b7f72a&scoped=true&"
import script from "./resourceHandles.vue?vue&type=script&lang=js&"
export * from "./resourceHandles.vue?vue&type=script&lang=js&"
import style0 from "./resourceHandles.vue?vue&type=style&index=0&id=33b7f72a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b7f72a",
  null
  
)

component.options.__file = "resourceHandles.vue"
export default component.exports